

<div class="container p-4">
    <h2>Zitierrichtlinie</h2>
   
    <p class="zitat">
        {{zitat}}
    </p>

    
    <button (click)="copyZitierrichtlinie()" matTooltip="Zitierrichtlinie kopieren" color="primary" mat-button>
        Zitierrichtlinie mit Verlinkung kopieren (html)
    </button>

</div>
